module.exports = __webpack_public_path__ + "static/media/자.71adc62a.jpg";